import { render, staticRenderFns } from "./EditFeedbackModal.vue?vue&type=template&id=6247b888&scoped=true"
import script from "./EditFeedbackModal.vue?vue&type=script&lang=js"
export * from "./EditFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./EditFeedbackModal.vue?vue&type=style&index=0&id=6247b888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247b888",
  null
  
)

export default component.exports